// extracted by mini-css-extract-plugin
module.exports = {"emailAddressContainer":"style_emailAddressContainer__cvGBx"};